import {
  COT20_FETCH_SERVICIOS_REQUEST,
  COT20_FETCH_SERVICIOS_SUCCESS,
  COT20_FETCH_SERVICIOS_FAILURE,
  SHOW_GLOBAL_LOADING,
  HIDE_GLOBAL_LOADING,
  COT20_FETCH_SET_ERROR_DIALOG_GLOBAL,
  COT20_FETCH_SET_SUCCESS_DIALOG_GLOBAL,
  COT20_FETCH_EJECUTIVOS_REQUEST,
  COT20_FETCH_EJECUTIVOS_SUCCESS,
  COT20_FETCH_EJECUTIVOS_FAILURE,
  COT20_FETCH_COMUNAS_DESTINO_REQUEST,
  COT20_FETCH_COMUNAS_DESTINO_SUCCESS,
  COT20_FETCH_COMUNAS_DESTINO_FAILURE,
  COT20_FETCH_PUERTOS_REQUEST,
  COT20_FETCH_PUERTOS_SUCCESS,
  COT20_FETCH_PUERTOS_FAILURE,
  COT20_FETCH_TIPOS_CARGAS_REQUEST,
  COT20_FETCH_TIPOS_CARGAS_SUCCESS,
  COT20_FETCH_TIPOS_CARGAS_FAILURE,
  COT20_FETCH_TIPOS_CONTENEDORES_REQUEST,
  COT20_FETCH_TIPOS_CONTENEDORES_SUCCESS,
  COT20_FETCH_TIPOS_CONTENEDORES_FAILURE,
  COT20_FETCH_TIPOS_INCOTERMS_REQUEST,
  COT20_FETCH_TIPOS_INCOTERMS_SUCCESS,
  COT20_FETCH_TIPOS_INCOTERMS_FAILURE,
  COT20_FETCH_NUMERO_WHATSAPP_REQUEST,
  COT20_FETCH_NUMERO_WHATSAPP_SUCCESS,
  COT20_FETCH_NUMERO_WHATSAPP_FAILURE,
  COT20_FETCH_SET_NUMERO_WHATSAPP,
  COT20_FETCH_SET_COTIZACION,
  COT20_FETCH_SET_COTIZACION_SUCCESS,
  COT20_FETCH_SET_COTIZACION_FAILURE,
  COT20_FETCH_SET_COTIZACION_ERRORS,
  COT20_FETCH_SET_COTIZACION_ERRORS_SUCCESS,
  COT20_FETCH_SET_COTIZACION_ERRORS_FAILURE,
  COT20_FETCH_GET_CLIENTE_BY_ID_SUCCESS,
  COT20_FETCH_GET_CLIENTE_BY_ID_FAILURE,
  COT20_FETCH_COTIZACION_20_SAVE,
  COT20_FETCH_COTIZACION_20_SAVE_SUCCESS,
  COT20_FETCH_COTIZACION_20_SAVE_FAILURE,
  COT20_FETCH_COTIZACION_20_ACCEPT,
  COT20_FETCH_COTIZACION_20_ACCEPT_SUCCESS,
  COT20_FETCH_COTIZACION_20_ACCEPT_FAILURE,
  COT20_FETCH_SERVICIOS_VALORES_REQUEST,
  COT20_FETCH_SERVICIOS_VALORES_SUCCESS,
  COT20_FETCH_SERVICIOS_VALORES_FAILURE,
  COT20_FETCH_SEND_EMAIL_COTIZACION,
  COT20_FETCH_SEND_EMAIL_COTIZACION_SUCCESS,
  COT20_FETCH_SEND_EMAIL_COTIZACION_FAILURE,
} from './actions';

const initialState = {
    isGlobalLoading: true,
    errorDialogGlobal: {
        open: false,
        title: '',
        message: '',
    },
    successDialogGlobal: {
        open: false,
        title: '',
        message: '',
    },
    numeroWhatsapp: '', 
    servicios: [],
    serviciosValores:[],
    ejecutivos: [],
    puertos: [],
    tiposCargas: [],
    tiposContenedores: [],
    tiposIncoterms: [],
    comunasDestino: [],
    cotizacion: {
        id: 0,
        estado:'NUEVA',
        contacto_nombre: '',
        contacto_apellido: '',
        contacto_correo: '',
        contacto_telefono: '',
        fk_ejecutivo: 0,
        fk_cliente: 0,
        fk_tracking: 0,
        fk_estado: 0,
        ejecutivo_whatsapp: '',
        fk_tipo_servicio: 0,
        carga_volumen: 0,
        carga_peso: 0,
        carga_detalles: '',
        dias_validez: 0,
        fk_puerto_origen: 0,
        fk_comuna_destino: 0,
        fk_tipo_contenedor: 0,
        fk_incoterm: 0,
        fk_tipo_carga: 0,
        fecha_creacion: '',
        fecha_actualizacion: '',
        fecha_cotizacion: '',
        fecha_validez: '',
        comentario: '',
        valor_producto: 0,
        valor_flete: 0,
        valor_seguro: 0,
        valor_gestion_china: 0,
        valor_flete_china: 0,
        valor_margen: 0,
        valor_aforo: 0,
        valor_neto: 0, 
        valor_iva: 0,
        valor_total: 0,
        valor_base:0,
        unidades:0,
    },
    cotizacionErrors: {
        estado: '',
        contacto_nombre: '',
        contacto_apellido: '',
        contacto_correo: '',
        contacto_telefono: '',
        fk_ejecutivo: '',
        fk_cliente: '',
        fk_tracking: '',
        fk_estado: '',
        ejecutivo_whatsapp: '',
        fk_tipo_servicio: '',
        carga_volumen: '',
        carga_peso: '',
        carga_detalles: '',
        dias_validez: '',
        fk_puerto_origen: '',
        fk_comuna_destino: '',
        fk_tipo_contenedor: '',
        fk_incoterm: '',
        fk_tipo_carga: '',
        fecha_creacion: '',
        fecha_actualizacion: '',
        fecha_cotizacion: '',
        fecha_validez: '',
        comentario: '',
        valor_producto: '',
        valor_flete: '',
        valor_seguro: '',
        valor_gestion_china: '',
        valor_flete_china: '',
        valor_margen: '',
        valor_aforo: '',
        valor_neto: '',
        valor_iva: '',
        valor_total: '',
        valor_base: '',
        unidades:'',
    },
};

export default function cot20Reducer(state = initialState, action) {
    switch (action.type) {
        case COT20_FETCH_COMUNAS_DESTINO_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_COMUNAS_DESTINO_SUCCESS:
            return {
                ...state,
                comunasDestino: action.payload,
            };
        case COT20_FETCH_COMUNAS_DESTINO_FAILURE:
            return {
                ...state,
                comunasDestino: [],
            };
        case COT20_FETCH_SEND_EMAIL_COTIZACION:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_SEND_EMAIL_COTIZACION_SUCCESS:
            return {
                ...state,
                isGlobalLoading: false,
            };
        case COT20_FETCH_SEND_EMAIL_COTIZACION_FAILURE:
            return {
                ...state,
                isGlobalLoading: false,
            };
        case COT20_FETCH_SERVICIOS_VALORES_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_SERVICIOS_VALORES_SUCCESS:
            return {
                ...state,   
                serviciosValores: action.payload,
            };
        case COT20_FETCH_SERVICIOS_VALORES_FAILURE:
            return {
                ...state,
                serviciosValores: [],
            };
        case COT20_FETCH_COTIZACION_20_ACCEPT:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_COTIZACION_20_ACCEPT_SUCCESS:
            return {
                ...state,
                cotizacion: action.payload,
            };
        case COT20_FETCH_COTIZACION_20_ACCEPT_FAILURE:
            return {
                ...state,
                cotizacion: {},
            };
        case COT20_FETCH_COTIZACION_20_SAVE:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_COTIZACION_20_SAVE_SUCCESS:
            return {
                ...state,   
                cotizacion: action.payload,
            };
        case COT20_FETCH_COTIZACION_20_SAVE_FAILURE:
            return {
                ...state,
                cotizacion: {},
            };
        case COT20_FETCH_GET_CLIENTE_BY_ID_SUCCESS:
            return {
                ...state,
                cotizacion: {
                    ...state.cotizacion,
                    nombre_contacto: action.payload.razon_social,
                    apellido_contacto: '',
                    correo: action.payload.correo,
                    telefono: action.payload.telefono,
                },
            };
        case COT20_FETCH_SET_COTIZACION:
            return {
                ...state,
                cotizacion: action.payload,
            };
        case COT20_FETCH_SET_COTIZACION_SUCCESS:
            return {
                ...state,
                cotizacion: action.payload,
            };
        case COT20_FETCH_SET_COTIZACION_FAILURE:
            return {
                ...state,
                cotizacion: {},
            };
        case COT20_FETCH_SET_COTIZACION_ERRORS:
            return {
                ...state,
                cotizacionErrors: action.payload,
            };
        case COT20_FETCH_SET_COTIZACION_ERRORS_SUCCESS  :
            return {
                ...state,
                cotizacionErrors: action.payload,
            };
        case COT20_FETCH_SET_COTIZACION_ERRORS_FAILURE:
            return {
                ...state,
                cotizacionErrors: {},
            };
        case COT20_FETCH_SET_NUMERO_WHATSAPP:
            return {
                ...state,
                numeroWhatsapp: action.payload,
            };
        case COT20_FETCH_NUMERO_WHATSAPP_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_NUMERO_WHATSAPP_SUCCESS:
            return {
                ...state,
                numeroWhatsapp: action.payload,
            };
        case COT20_FETCH_NUMERO_WHATSAPP_FAILURE:
            return {
                ...state,
                numeroWhatsapp: '',
            };
        case COT20_FETCH_TIPOS_INCOTERMS_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,  
            };
        case COT20_FETCH_TIPOS_INCOTERMS_SUCCESS:
            return {
                ...state,
                tiposIncoterms: action.payload,
            };
        case COT20_FETCH_TIPOS_INCOTERMS_FAILURE:
            return {
                ...state,
                tiposIncoterms: [],
            };
        case COT20_FETCH_TIPOS_CONTENEDORES_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_TIPOS_CONTENEDORES_SUCCESS:
            return {
                ...state,
                tiposContenedores: action.payload,
            };
        case COT20_FETCH_TIPOS_CONTENEDORES_FAILURE:
            return {
                ...state,
                tiposContenedores: [],
            };
        case COT20_FETCH_TIPOS_CARGAS_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_TIPOS_CARGAS_SUCCESS:
            return {
                ...state,
                tiposCargas: action.payload,
            };
        case COT20_FETCH_TIPOS_CARGAS_FAILURE:
            return {
                ...state,
                tiposCargas: [],
            };
        case COT20_FETCH_PUERTOS_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };  
        case COT20_FETCH_PUERTOS_SUCCESS:
            return {
                ...state,
                puertos: action.payload,
            };
        case COT20_FETCH_PUERTOS_FAILURE:
            return {
                ...state,
                puertos: [],
            };
        case COT20_FETCH_EJECUTIVOS_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_EJECUTIVOS_SUCCESS:
            return {
                ...state,
                ejecutivos: action.payload,
            };
        case COT20_FETCH_EJECUTIVOS_FAILURE:
            return {
                ...state,
                ejecutivos: [],
            };
        case COT20_FETCH_SERVICIOS_REQUEST:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case COT20_FETCH_SERVICIOS_SUCCESS:
            return {
                ...state,   
                servicios: action.payload,
            };
        case COT20_FETCH_SERVICIOS_FAILURE:
            return {
                ...state,
                servicios: [],
            };
        case COT20_FETCH_SET_SUCCESS_DIALOG_GLOBAL:
            return {
                ...state,
                successDialogGlobal: {
                    open: action.payload.open,
                    title: action.payload.title,
                    message: action.payload.message,
                },
            };
        case COT20_FETCH_SET_ERROR_DIALOG_GLOBAL:
            return {
                ...state,
                errorDialogGlobal: {
                    open: action.payload.open,
                    title: action.payload.title,
                    message: action.payload.message,
                },
            };
            
        case SHOW_GLOBAL_LOADING:
            return {
                ...state,
                isGlobalLoading: true,
            };
        case HIDE_GLOBAL_LOADING:
            return {
                ...state,
                isGlobalLoading: false,
            };
        default:
            return state;
    }
} 